import { createActionGroup, props } from '@ngrx/store';

import { CompanyLanguage, CustomLanguage } from '@ninety/mobile/platform/api';

export const LanguageActions = createActionGroup({
  source: 'Language',
  events: {
    'Get Company Language Success': props<{ companyLanguage: CompanyLanguage | null }>(),
    'Get Company Language Error': props<{ error: unknown }>(),

    Init: props<{
      companyLanguage: CompanyLanguage;
      defaultBOSLanguage: CustomLanguage;
    }>(),
  },
});
